import IconBase, { IconBaseProps } from "./IconBase";

const TIconLarge = (props: IconBaseProps) => (
  <IconBase {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 2v16h1a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2h1V2H2v1a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V2h-7z"
    />
  </IconBase>
);

export default TIconLarge;
